import axios from 'axios'

export interface Response<T> {
  data: T,
}

const axiosInstance = axios.create({
  baseURL: 'http://localhost:2525',
})

export default axiosInstance
